<template>
  <v-card>
    <v-card-title
      class="d-flex justify-space-between align-center px-6 px-lg-10 py-6"
    >
      <h2 class="ma-0 text-bold font-28 primary--text">
        {{
          $vuetify.breakpoint.lgAndUp
            ? "Rent protection & Legal expenses eligibility check"
            : "Eligibility check"
        }}
      </h2>
      <v-btn icon class="btn-close" aria-label="Close" @click="cancel">
        <img src="@/assets/icons/ic_close.svg" />
      </v-btn>
    </v-card-title>

    <v-divider></v-divider>

    <v-card-text
      :style="`height: ${pslScrollHeight}`"
      class="pl-6 pl-lg-10 pr-1 pr-lg-5 py-6"
    >
      <BaseAlert
        color="var(--blue-100)"
        class="mb-6 border-sm border-solid border-info"
      >
        <div class="d-flex">
          <div class="mr-3">
            <v-icon color="var(--blue-500)">mdi-information</v-icon>
          </div>
          <div class="primary--text">
            <span class="font-weight-bold">Important!</span>
            Please confirm that you meet all of the below eligibility criteria.
            Take care to ensure that the information you provide is accurate to
            the best of your knowledge, otherwise your premium could increase,
            your claim may be refused or your policy could be voided
          </div>
        </div>
      </BaseAlert>

      <ul>
        <li
          class="d-flex"
          v-for="(eligibility, index) in LANDLORD_ELIGIBILITY_COVER"
          :key="index"
        >
          <span class="flex-shrink-0 white--text">{{ eligibility?.id }}</span>
          <div>
            <p class="font-16 mb-2 primary--text">
              {{ eligibility?.text }}
            </p>
            <div class="expand__wrapper d-flex align-start mb-2">
              <v-icon
                @click="
                  indexOfContentExpand === index
                    ? closeExpandContent()
                    : expandContent(index)
                "
              >
                {{
                  indexOfContentExpand === index
                    ? eligibility?.iconClose
                    : eligibility?.iconOpen
                }}
              </v-icon>
              <a
                class="action__item"
                v-if="eligibility?.expandContent"
                @click="
                  indexOfContentExpand === index
                    ? closeExpandContent()
                    : expandContent(index)
                "
                >{{ eligibility?.eventTextDisplay }}
              </a>
            </div>
            <div
              v-if="indexOfContentExpand === index"
              class="expand-content__wrapper"
              v-html="eligibility?.expandContent"
            ></div>
          </div>
        </li>
      </ul>
    </v-card-text>

    <v-divider></v-divider>

    <v-card-actions class="px-6 px-lg-10 py-6">
      <div class="d-flex flex-column justify-center align-center flex-grow-1">
        <BaseButton
          text="CONFIRM ELIGIBILITY"
          rounded
          depressed
          height="60"
          class="font-weight-bold font-20 mb-4 text-uppercase"
          :color="'psorange'"
          :min-width="$vuetify.breakpoint.lgAndUp ? '420' : '100%'"
          @click="handleConfirmEligibility"
        >
        </BaseButton>

        <a
          @click="handleEligibilityNotMet"
          class="font-18 text-decoration-underline"
          >Don't meet eligibility criteria?</a
        >
      </div>
    </v-card-actions>
  </v-card>
</template>

<script>
import { LANDLORD_ELIGIBILITY_COVER } from "@/constants/eligibility.constants";
import BaseButton from "@/components/BaseComponents/BaseButton.vue";
import BaseAlert from "@/components/BaseComponents/BaseAlert.vue";

export default {
  name: "EligibilityCover",
  components: {
    BaseButton,
    BaseAlert,
  },
  props: {
    pslScrollHeight: {
      type: String,
      default: "auto",
    },
  },
  data() {
    return {
      indexOfContentExpand: -1,
      LANDLORD_ELIGIBILITY_COVER,
    };
  },
  methods: {
    expandContent(index) {
      this.indexOfContentExpand = index;
    },
    closeExpandContent() {
      this.indexOfContentExpand = -1;
    },
    handleConfirmEligibility() {
      this.$emit("confirm-eligibility");
    },
    handleEligibilityNotMet() {
      this.$emit("eligibility-not-meet");
    },
    cancel() {
      this.$emit("cancel-eligibility");
    },
  },
};
</script>

<style lang="scss" scoped>
:deep(.v-card__title) {
  h2 {
    max-width: 80%;
    word-break: break-word;
  }
}

:deep(.v-card__text) {
  ul {
    list-style: none;
    margin: 0;
    padding: 0 0 0 4px;

    li {
      margin-bottom: 8px;

      &:last-child {
        margin-bottom: 0;
      }

      span {
        background: $stepper-active;
        border-radius: 50%;
        font-size: 18px;
        font-weight: 800;
        height: 28px;
        margin-right: 24px;
        width: 28px;

        display: flex;
        justify-content: center;
        align-items: center;
      }
      p {
        margin: 0;
      }

      .expand__wrapper {
        .action__item {
          color: #106175;
          font-size: 16px;
          font-weight: 600;
          text-decoration: underline;
        }
        .v-icon {
          color: #106175;
        }
      }
    }
  }

  .expand-content__wrapper {
    padding-left: 16px;
    margin-left: 10px;
    border-left: 2px solid #106175;
    font-size: 16px;
  }
}
</style>
